module.exports = __webpack_public_path__ + "static/media/new.e581ab99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/new.svg
// module id = 1048
// module chunks = 3